import { createContext, type ReactNode } from 'react'

/** Pack canvas launchers and glances for the current page; set by the page pane. */
export const PageHeaderPluginActionsContext = createContext<{ actions: ReactNode; below: ReactNode } | null>(
  null,
)
